<template>
  <b-card style="height: 600px">
    <b-card-title>设备或系统运行状态</b-card-title>
    <div>
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <b-icon-hdd-rack-fill />
          <span class="ml-1">常规冷源系统</span>
        </div>
        <div>
          <span class="bullet bullet-success bullet-sm"></span>
          <span class="bullet bullet-secondary bullet-sm ml-50"></span>
          <span class="bullet bullet-secondary bullet-sm ml-50"></span>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between mt-75">
        <div>
          <b-icon-gear-wide-connected />
          <span class="ml-1">冷却水系统</span>
        </div>
        <div>
          <span class="bullet bullet-secondary bullet-sm"></span>
          <span class="bullet bullet-secondary bullet-sm ml-50"></span>
          <span class="bullet bullet-success bullet-sm ml-50"></span>
          <span class="bullet bullet-secondary bullet-sm ml-50"></span>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between mt-75">
        <div>
          <b-icon-gear-wide-connected />
          <span class="ml-1">冷冻水系统</span>
        </div>
        <div>
          <span class="bullet bullet-success bullet-sm"></span>
          <span class="bullet bullet-secondary bullet-sm ml-50"></span>
          <span class="bullet bullet-secondary bullet-sm ml-50"></span>
          <span class="bullet bullet-secondary bullet-sm ml-50"></span>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between mt-75">
        <div>
          <b-icon-server />
          <span class="ml-1">太阳能集热系统</span>
        </div>
        <div>
          <span class="bullet bullet-secondary bullet-sm"></span>
          <span class="bullet bullet-secondary bullet-sm ml-50"></span>
          <span class="bullet bullet-success bullet-sm ml-50"></span>
        </div>
      </div>
    </div>
    <hr class="offsetMargin" />
    <b-row>
      <b-col cols="6">
        <div id="project-detail-equipment-liquid" style="height: 8rem"></div>
      </b-col>
      <b-col cols="6" class="d-flex align-items-center">
        <div>
          <h4 class="my-0"><span class="font-digit">350.1</span> <small>kWh</small></h4>
          <label>制冷量</label>
          <h5 class="mb-0 mt-50"><span class="font-digit">62.5</span> <small>kWh</small></h5>
          <label>耗电量</label>
        </div>
      </b-col>
    </b-row>
    <hr class="offsetMargin" />
    <div v-for="(item, index) in efficiencyList" :key="index" class="d-flex align-items-center justify-content-between" style="margin-bottom: 0.3rem">
      <div>
        <b-avatar size="32" :variant="'light-' + item.color">
          <b-icon :icon="item.icon"></b-icon>
        </b-avatar>
        <span class="ml-1">{{ item.title }}</span>
      </div>
      <h5 class="font-digit my-0" :class="'text-' + item.color">
        {{ item.value }}
      </h5>
    </div>
  </b-card>
</template>

<script>
import { Column, Liquid } from '@antv/g2plot';
import { $themeColors } from '@themeConfig';
import { onMounted } from '@vue/composition-api';

export default {
  name: 'Equipment',
  data() {
    return {
      efficiencyList: [
        {
          title: '1#热泵运行能效',
          value: '4.6',
          icon: 'filter-circle-fill',
          color: 'primary',
        },
        {
          title: '2#热泵运行能效',
          value: '4.2',
          icon: 'filter-square-fill',
          color: 'success',
        },
        {
          title: '吸收式制冷机效率',
          value: '0.6',
          icon: 'hdd-rack-fill',
          color: 'warning',
        },
        {
          title: '太阳能集热器效率',
          value: '0.7',
          icon: 'layers-half',
          color: 'info',
        },
        {
          title: '可再生能源利用率',
          value: '6%',
          icon: 'lightning-fill',
          color: 'danger',
        },
        {
          title: '输配系统效率',
          value: '0.8',
          icon: 'bezier',
          color: 'primary',
        },
        {
          title: '可再生能源消纳比',
          value: '50%',
          icon: 'bar-chart-fill',
          color: 'success',
        },
      ],
    };
  },
  setup() {
    const liquidChartInit = () => {
      const liquidPlot = new Liquid(document.getElementById('project-detail-equipment-liquid'), {
        theme: {
          colors10: Object.values($themeColors),
        },
        color: () => {
          return $themeColors.primary;
        },
        percent: 0.56,
        radius: 1,
        statistic: {
          title: {
            formatter: () => 'SCOP',
            style: ({ percent }) => ({
              fontSize: '0.9rem',
              fill: percent >= 0.65 ? 'white' : '',
            }),
          },
          content: {
            style: ({ percent }) => ({
              fontSize: '1.286rem',
              fill: percent >= 0.5 ? 'white' : '',
            }),
            customHtml: (container, view, { percent }) => {
              const text = `${(percent * 10).toFixed(1)}`;
              return `<div>${text}</div>`;
            },
          },
        },
      });
      liquidPlot.render();
    };
    const columnChartInit = () => {
      const stackedColumnPlot = new Column('project-detail-equipment-column', {
        theme: {
          colors10: Object.values($themeColors),
        },
        data: [
          {
            name: '供冷量',
            month: '一月',
            energy: 0,
          },
          {
            name: '供冷量',
            month: '二月',
            energy: 0,
          },
          {
            name: '供冷量',
            month: '三月',
            energy: 100,
          },
          {
            name: '供冷量',
            month: '四月',
            energy: 300,
          },
          {
            name: '供冷量',
            month: '五月',
            energy: 1200,
          },
          {
            name: '供冷量',
            month: '六月',
            energy: 1500,
          },
          {
            name: '供冷量',
            month: '七月',
            energy: 2000,
          },
          {
            name: '供冷量',
            month: '八月',
            energy: 1800,
          },
          {
            name: '供冷量',
            month: '九月',
            energy: 1200,
          },
          {
            name: '供冷量',
            month: '十月',
            energy: 300,
          },
          {
            name: '供冷量',
            month: '十一月',
            energy: 0,
          },
          {
            name: '供冷量',
            month: '十二月',
            energy: 0,
          },
          {
            name: '供热量',
            month: '一月',
            energy: 1500,
          },
          {
            name: '供热量',
            month: '二月',
            energy: 1200,
          },
          {
            name: '供热量',
            month: '三月',
            energy: 800,
          },
          {
            name: '供热量',
            month: '四月',
            energy: 100,
          },
          {
            name: '供热量',
            month: '五月',
            energy: 0,
          },
          {
            name: '供热量',
            month: '六月',
            energy: 0,
          },
          {
            name: '供热量',
            month: '七月',
            energy: 0,
          },
          {
            name: '供热量',
            month: '八月',
            energy: 0,
          },
          {
            name: '供热量',
            month: '九月',
            energy: 100,
          },
          {
            name: '供热量',
            month: '十月',
            energy: 500,
          },
          {
            name: '供热量',
            month: '十一月',
            energy: 1000,
          },
          {
            name: '供热量',
            month: '十二月',
            energy: 1200,
          },
        ],
        isGroup: true,
        xField: 'month',
        yField: 'energy',
        seriesField: 'name',
        /** 设置颜色 */
        color: [$themeColors.warning, $themeColors.primary],
        label: false,
        xAxis: {
          label: {
            autoHide: true,
            autoRotate: false,
          },
          line: null,
          grid: null,
          tickLine: null,
        },
        yAxis: {
          line: null,
          grid: null,
          label: null,
        },
        columnStyle: {
          radius: [5, 5, 5, 5],
        },
        legend: {
          position: 'top',
        },
      });

      stackedColumnPlot.render();
    };

    onMounted(() => {
      liquidChartInit();
    });
  },
};
</script>

<style lang="scss" scoped>
.offsetMargin {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}
</style>
